import * as React from 'react';
import {YearMonth} from "./utils/YearMonthRangePicker";
import furoApi from "../api/FuroApi";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import {Client, ErrorResponse} from "../api/dtos/dtos";
import {ErrorAlert} from "../common/ErrorAlert";
import './utils/Statistics.css';
import {CategoryValue, StatisticsRequest} from "../api/dtos/statistics";
import CategoryDistributionStatisticsPanel from "./CategoryDistributionStatisticsPanel";

interface Props {
  client: Client;
}

interface State {
  costStatistics?: CategoryValue[];
  usageStatistics?: CategoryValue[];
  error?: ErrorResponse;
}

class ClientStatisticsPage extends React.Component<Props, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {};

  public render(): React.ReactNode {
    const {costStatistics, usageStatistics, error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <CategoryDistributionStatisticsPanel
          onQueryParamsChange={this.onQueryParamsChange}
          costStatistics={costStatistics}
          usageStatistics={usageStatistics}
        />

        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }

  private onQueryParamsChange = (start: YearMonth, end: YearMonth) => {
    const {client} = this.props;
    const request: StatisticsRequest = {
      startYear: start.year,
      startMonth: start.month,
      endYear: end.year,
      endMonth: end.month
    };
    this.loadStatisticsInRange(client.id!, request);
  };

  private loadStatisticsInRange = (clientId: number, request: StatisticsRequest) => {
    const promise = furoApi.statistics.getClientStatistics(clientId, request)
      .then(response => this.setState({
        costStatistics: response.categoryCostStatistics,
        usageStatistics: response.categoryUsageStatistics,
        error: undefined,
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default ClientStatisticsPage;


// WEBPACK FOOTER //
// ./src/statistics/ClientStatisticsPage.tsx